import type { PromoResponse } from '@/store/types/promo'
import T from '@/components/Helpers/Translate'
import Image from 'next/image'
import useGlobalStore from '@/store/useGlobalStore'

type Props = {
  product: PromoResponse
}
export const PromoItem = ({ product }: Props) => {
  const {
    cart: { addedLines },
  } = useGlobalStore()

  const getAddedLinesDataForSku = ({ sku }: { sku: string }) =>
    addedLines.items?.find((line) => line.item.id.unicity === sku)

  return (
    <div
      className="mx-5 mb-2 flex flex-row items-center space-x-4 rounded-lg bg-amber-500/10 p-3 md:m-0"
      key={product.data.slug}
    >
      <div key={product.data.name} className="flex">
        <Image
          width={70}
          height={70}
          alt=""
          // @ts-expect-error Cosmic sends the wrong structure for this use case
          src={product.data.image?.imageUrl || product.data.image || ''}
        />
      </div>
      <div className="about">
        <div className="text-small text-amber-500">
          <T>free</T>
        </div>
        <div className="name font-bold text-primary">
          {' '}
          {
            getAddedLinesDataForSku({ sku: product.data.variations?.[0]?.sku })
              ?.quantity
          }
          x {product.data.name}
        </div>
      </div>
    </div>
  )
}
